module.exports = __webpack_public_path__ + "static/img/W.6d77d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leishenx/W.png
// module id = dua0
// module chunks = 0